module.exports = "https://static.wmbcdn.com/uniweb/images/64c954f75c804802ecac94d8e0cb8b9b.svg";